import { render, staticRenderFns } from "./SInputNumber.vue?vue&type=template&id=6edd4a63&scoped=true"
import script from "./sInputNumber.ts?vue&type=script&lang=ts&external"
export * from "./sInputNumber.ts?vue&type=script&lang=ts&external"
import style0 from "./SInputNumber.vue?vue&type=style&index=0&id=6edd4a63&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edd4a63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6edd4a63')) {
      api.createRecord('6edd4a63', component.options)
    } else {
      api.reload('6edd4a63', component.options)
    }
    module.hot.accept("./SInputNumber.vue?vue&type=template&id=6edd4a63&scoped=true", function () {
      api.rerender('6edd4a63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-input-number/SInputNumber.vue"
export default component.exports